<template>
  <div class="test">
    <div class="wrapper">
      <h2>Тестовое задание от Klerk</h2>
      <div class="time">
        <div class="time__name">Время в часовых поясах</div>
        <div class="time__buttons" v-if="timeZoneArray && timeZoneArray.length">
          <button class="time__button"
                  :class="{'time__button_active':itemZone.zone===timeZone}"
                  :title="itemZone.title" v-for="(itemZone, indexZone) in timeZoneArray"
                  :key="indexZone"
                  v-on:click="timeShow(itemZone.zone)">{{itemZone.name}}
          </button>
        </div>
        <div class="block-loader" v-if="this.blockLoader">
          <img src="../../assets/loader.gif" class="block-loader__img">
        </div>
        <div class="time__show" v-else v-show="inputTime">{{this.inputTime}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "Klerk",

  data () {
    return {
      blockLoader: false,
      timeZoneArray: [
        {name:'Москва', title:'Время в Москве', zone:'Europe/Moscow'},
        {name:'Нью-Йорк', title:'Время в Нью-Йорке', zone:'America/New_York'},
        {name:'Владивосток', title:'Время во Владивостоке', zone:'Asia/Vladivostok'}
      ],
      timeZone: '',
      inputTime: '',
      ticking: ''
    }
  },

  methods: {
    timeApi (zone) {
      axios.get('https://worldtimeapi.org/api/timezone/'+zone).then((response) => {
        this.inputTime = this.timeServer(response.data.datetime)
        this.blockLoader = false
        this.ticking = setInterval(() => {
          this.inputTime = this.timeTicking(this.inputTime)
        }, 1000)
      })
    },

    timeServer (time) {
      return time.split('.')[0].split('T')[1]
    },

    timeTicking (time) {
      let timeArray = time.split(':'),
        h = Number.parseInt(timeArray[0]),
        m = Number.parseInt(timeArray[1]),
        s = Number.parseInt(timeArray[2])
      s++
      if (s > 59) {
        s = 0
        m++
        if (m > 59) {
          m = 0
          h++
          if (h > 23) {
            h = 0
          }
        }
      }
      s = s < 10 ? '0' + s : s
      m = m < 10 ? '0' + m : m
      h = h < 10 ? '0' + h : h
      return h + ':' + m + ':' + s
    },

    timeShow (zone) {
      if (zone === this.timeZone) return
      this.blockLoader = true
      clearInterval(this.ticking)
      this.timeApi(zone)
      this.timeZone = zone
    }
  }
}
</script>

<style lang="scss" scoped>
  .test {
    position: relative;
    margin: 30px 0 0;
  }

  .time {
    margin: 30px 0 0;

    &__name {
      margin: 30px 0 0;
      text-align: center;
      @include font(22px, 28px, $color-dark-gray);
      font-weight: bold;
    }

    &__buttons {
      margin: 30px 0 0;
      text-align: center;
    }

    &__button {
      display: inline-table;
      height: 28px;
      padding: 0 10px;
      border: 1px solid $color-link;
      border-radius: 10px;
      background: $color-link;
      cursor: pointer;
      @include font(14px, 18px, #ffffff);

      @media screen and (min-width: 1024px){
        height: 38px;
        padding: 0 18px;
      }

      &:hover:not(&_active) {
        background: $color-link-hover;
        border-color: $color-link-hover;
      }

      & + & {
        margin: 0 0 0 10px;
      }

      &_active {
        background: #ffffff;
        cursor: default;
        color: $color-link;
      }
    }

    &__show {
      margin: 50px 0;
      text-align: center;
      font-family: Roboto-Bold, sans-serif;
      @include font(50px, 1, $bg-color);

      @media screen and (min-width: 680px){
        @include font(80px, 1, $bg-color);
      }

      @media screen and (min-width: 1024px){
        @include font(120px, 1, $bg-color);
      }
    }

    .block-loader {
      margin: 50px 0;
    }
  }
</style>
